import * as log from "loglevel";
if (process.env.NODE_ENV !== "production") {
  log.setLevel(1); // 0-5
} else {
  log.setLevel(5); // 0-5
}

export default log;
